import React from 'react'
import { useTranslation } from "react-i18next";
import { UserType } from "src/constants/usertype";
import RightChevron from 'src/images/icon_rightchevron.svg';

interface Props {
    userType: UserType;
    iconSrc: string;
    onClick: () => void;
    hidden?: boolean;
}

export default function UserSelectionTile({userType,
                                           iconSrc,
                                           onClick,
                                           hidden = false
                                        }: Props) {
    const { t } = useTranslation();
    const className = `content-box tile-container ${hidden ? 'hidden' : ''}`
    const userTypeString = userType.toLowerCase();
    const divId = `${userTypeString}-picker`;
    const textDivId = `${userTypeString}-login-text`;
    const loginText1 = `${userTypeString}_login_text_1`;
    const loginText2 = `${userTypeString}_login_text_2`;
    return (
        <div id={divId} className={className}
            onClick={onClick}>
            <img className="icon" src={iconSrc} />
            <div id={textDivId}><b>{t(loginText1)}</b><br />{t(loginText2)}</div>
            <img className="chevron" src={RightChevron} />
        </div>
    )
}